<template>
    <div>
        <div class="nav">
            <p>我要提现</p> 
        </div>
        <van-icon name="arrow-left"  class="icon" @click="icon"/>

        <div class="money">
            <ul>
                <li><input type="text" placeholder="请输入您要提现的金额"></li>
                <li>¥ <span>200.00</span> </li>
                <li>我的余额：¥<span>823.00</span></li>
            </ul>
        </div>

        <van-radio-group v-model="radio">
            <van-radio name="1">
                单选框 1
                <img
                slot="icon"
                slot-scope="props"
                :src="props.checked ? activeIcon : inactiveIcon"
                >
            </van-radio>
            <van-radio name="2">
                单选框 2
                <img
                slot="icon"
                slot-scope="props"
                :src="props.checked ? activeIcon : inactiveIcon"
                >
            </van-radio>
            <van-radio name="3">
                单选框 3
                <img
                slot="icon"
                slot-scope="props"
                :src="props.checked ? activeIcon : inactiveIcon"
                >
            </van-radio>
        </van-radio-group>

        <div class="btn" @click="btn">确认提现</div>

        <div class="foot">
            <p>提现说明</p>
            <p>提现说明，这是提现说明。。。邀请一位获得多少经验值，经验值多了可以干嘛干嘛，等级越高，账号怎么第更什么。</p>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Icon } from 'vant';
import { RadioGroup, Radio } from 'vant';

Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Icon);
export default {
    data() {
        return{
            radio: '1',
            activeIcon: 'https://img.yzcdn.cn/vant/user-active.png',
            inactiveIcon: 'https://img.yzcdn.cn/vant/user-inactive.png'
        }
    },
    methods:{
        icon(){
            this.$router.go(-1)
        },
        btn(){
            alert(123)
        }
    },

}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
}

.icon{
    vertical-align: middle;
    position: fixed;
    line-height: 46px;
    left: 15px;
    top: 0;
    color: #fff;
    z-index: 2
}
.nav{
    width: 100%;
    background-image: linear-gradient(to right, #406df8 , #6289fe);
    line-height: 46px;
    text-align: center;
    color: #fff;
    vertical-align: middle;
}
.money{
    width: 90%;
	background-color: #ffffff;
	box-shadow: 0px 0px 16px 0px 
		rgba(200, 200, 200, 0.4);
	border-radius: 10px;
    margin: 15px auto;
}
ul li:first-child input{
    width: 100%;
    padding: 15px 0 0 15px;
    border: none;
	font-size: 14px;
	color: #adadad;
}
ul li:nth-child(2){
    line-height: 75px;
    font-size: 36px;
    color: #3c69f5;
    text-indent: 15px;
}
ul li:last-child{
    border-top: 1px solid #746a6a;
    line-height: 40px;
    text-indent: 15px;
    color: #565656;
    font-size: 14px;
}

.van-radio{
    padding: 5px 30px;
}
.van-radio img{
    width: 15px;
}

.btn{
    background-image: linear-gradient(to right, #406df8 , #6289fe);
    width: 90%;
    line-height: 43px;
    margin: 25px auto;
    color: #f2f2f2;
    text-align: center;
    border-radius: 21px;
}

.foot p:first-child{
	font-size: 18px;
	line-height: 60px;
    font-weight: 400;
	color: #000000;
    width: 90%;
    margin: 0 auto;
}
.foot p:last-child{
    color: #565656;
    text-indent: 2em;
    font-size: 14px;
	line-height: 24px;
    font-weight: 400;
    width: 90%;
    margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/TheOrder/theorder.vue